import React, { Component } from 'react';
import moment from 'moment';

import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';

import {handleChange, getError} from 'components/Base/RenderField';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';
import { ActionPermIdentity } from 'material-ui/svg-icons';

export default class Subscription extends Component {

  state = {
    amount: 1,
    period: 'months', //months, years, days
    trial: false,
    errors: {},
    error: ''
  }

  handleChange = handleChange.bind(this);

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data } = nextProps;

    if (nextProps.data) {
      let dataIsEmpty = true;

      for (let key in data) {
        dataIsEmpty = false;
        break;
      }

      if (!dataIsEmpty) { 
        this.setState({
          trial: data.trial,
        });
      } 
    }
  }

  // not necessary due to stripe integration
  // extendSubscription = async () => {
  //   let { fetchUser, data } = this.props;
  //   let { period, amount, trial } = this.state;

  //   let result = await api.users.extendSubscription(data._id, {period, amount, trial});

  //   if (result.status === 200) {
  //     await fetchUser();
  //     return showNotification('User\'s subscription has been updated');
  //   }

  //   this.setState({...getNormalErrors(result)})
  //   showNotification(this.state.error, 'error')
  // }

  render() {
    let { data: { endAt, subscriptions = [] } } = this.props;
    let { period, amount, trial } = this.state;

    return (
      <div>
        <h4>SUBSCRIPTION</h4>
        <div className='m-t-1'>
          {`Subscription ends at ${moment(endAt).format('DD.MM.YYYY')}`}
        </div>
        {/* <div className='m-t-1'>
          Extend to:
        </div> */}
        <div className='m-t-1'>
          <div className='row'>
            {/* not necessary due to stripe integration */}
            {/* <div className='col-md-12'>
              <SelectField
                hintText="Select period"
                value={period}
                onChange={(event, index, value) => this.handleChange('period', value)}
                fullWidth
              >
                <MenuItem
                  checked={period === 'days'}
                  value={'days'}
                  primaryText={'Days'}
                />
                <MenuItem
                  checked={period === 'months'}
                  value={'months'}
                  primaryText={'Months'}
                />
                <MenuItem
                  checked={period === 'years'}
                  value={'years'}
                  primaryText={'Years'}
                />
              </SelectField>
            </div> */}
            {/* <div className='col-md-12'>
              <SelectField
                hintText="Select amount"
                value={period !== 'days' && amount > 12 ? 12 : amount }
                onChange={(event, index, value) => this.handleChange('amount', value)}
                fullWidth
              >
                {
                  [...new Array(period === 'days' ? 31 : 12)].map((e, i) => {
                    return (
                      <MenuItem
                        key={`amount-${i + 1}`}
                        checked={amount === i}
                        value={i}
                        primaryText={i || "0"}
                      />
                    )
                  })
                }
              </SelectField>
            </div> */}
            {/* <div className='col-md-12'>
              <Checkbox
                checked={trial}
                onCheck={(e, value) => this.handleChange('trial', value)}
                label="Trial period (Main deck blur)"
              />
            </div> */}
            {/* <div className='col-md-12 text-center m-t-1'>
              <FlatButton
                label='Update'
                primary
                onClick={this.extendSubscription}
              />
            </div> */}
            {
              subscriptions.length &&
                <div className='col-md-12 m-t-2'>
                  <div className='payment-history'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='text-center bold'>
                          Billing History
                        </div>
                      </div>
                      <div className='col-md-12 m-t-1 payment-history_header'>
                        <div className='row'>
                          <div className='col-md-4'>
                            Date
                          </div>
                          <div className='col-md-4'>
                            Subscription is active
                          </div>
                          <div className='col-md-4'>
                            Status
                          </div>
                        </div>
                      </div>
                      {
                        [...subscriptions].reverse().map(sc => {
                          return (
                            <div
                              className='col-md-12 payment-history_entry'
                              key={sc.addedAt}
                            >
                              <div className='row'>
                                <div className='col-md-4'>
                                  {moment(sc.addedAt).format('DD.MM.YYYY HH:mm')}
                                </div>
                                <div className='col-md-4'>
                                  {`${moment(sc.from).format('DD.MM.YYYY')} - ${moment(sc.to).format('DD.MM.YYYY')}`}
                                </div>
                                <div className='col-md-4'>
                                  {sc.statusText}
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Users/Details/Subscription.js